import { StorageType } from '@/typings/enum/Common'

class HyStore {
  private readonly engine: Storage

  constructor(type: StorageType) {
    this.engine = type === StorageType.Local ? localStorage : sessionStorage
  }

  public setItem(key: string, value: any): void {
    this.engine.setItem(key, JSON.stringify(value))
  }

  public getItem(key: string): any {
    const value = this.engine.getItem(key)
    try {
      if (value) {
        return JSON.parse(value)
      }
      return null
    } catch {
      return value
    }
  }

  public removeItem(key: string): void {
    this.engine.removeItem(key)
  }
}

export default HyStore
